import React from 'react';
import {BaseInputProps} from '../..';

import {Switch as MantineSwitch, Tooltip} from '@mantine/core';
import {useController, useFormContext} from 'react-hook-form';
import {NestedKeys} from 'shared/types/key-manipulation';

import {RiInformationFill} from 'react-icons/ri';
import {Container, ContainerLabel, Label, Row} from './styles';
import {useTheme} from 'styled-components';

export type SwitchProps<T = any> = BaseInputProps & {
  name: NestedKeys<T>;
  gridColumn?: number;
};

const Switch: React.FC<SwitchProps> = ({
  name,
  label,
  gridColumn,
  border,
  disabled,
  information,
}) => {
  const {control} = useFormContext();
  const {field} = useController({control: control, name});
  const {colors} = useTheme();

  const handleOnSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    !disabled && field.onChange(event);
  };

  return (
    <Container {...{gridColumn, border}}>
      <ContainerLabel>
        {label && <Label>{label}</Label>}
        {information && (
          <Tooltip
            label={information}
            multiline
            withArrow
            arrowSize={10}
            openDelay={500}
            w={200}
            position="top">
            <div>
              <RiInformationFill size={20} />
            </div>
          </Tooltip>
        )}
      </ContainerLabel>
      <Row>
        <MantineSwitch
          styles={{
            root: {display: 'flex', alignItems: 'center', color: colors.text},
            track: {backgroundColor: !field.value ? colors.text : undefined},
          }}
          onChange={handleOnSwitchChange}
          checked={field.value ?? false}
        />
        {field.value ? 'Sim' : 'Não'}
      </Row>
    </Container>
  );
};

export default Switch;
